import React from "react";
import classes from "./PageContainer.module.css";
const PageContainer = (props) => {
  return <div className={classes["dahb-main"]}>{props.children}</div>;
};

export default PageContainer;
